import React, { useState } from 'react';
// Icons
import { BsInfoCircle } from 'react-icons/bs';
// Styles
import './Info.css';
// Translate
import { useTranslation } from 'react-i18next';

const Info = () => {
  const { t } = useTranslation();
  const [showMessage, setShowMessage] = useState(false);

  const getExamples = () => {
    return (
      <div className='messageInfo'>
        <p>
          {t('Aquino is your artificial intelligence assistant')}
        </p>
      </div>
    );
  };

  return (
    <button
      className='message-containerInfo'
      onMouseEnter={() => setShowMessage(true)}
      onMouseLeave={() => setShowMessage(false)}
    >
      <BsInfoCircle />
      {showMessage && getExamples()}
    </button>
  );
};

export default Info;
